import { AdditionalFilter } from "../rulebook/additional-filter";
import { RiskControl } from "./riskControl";

export class RiskControlFilter extends AdditionalFilter{
    id:string;
    filterType: string;
    fromDate: string | null;
    toDate: string | null;
    riskRef: string[];
    riskArea: string[];
    riskCategory: string[];
    riskTitle: string[];
    complianceTopic: string[];
    entitiesImpacted: string[];
    riskOwner: string[];
    riskDescription: string[];
    applicableRules: string[];
    inherentRiskRating:string[];
    residualRiskRating:string[];
    pageSize: number = 10;
    pageIndex: number = 1;
  
  constructor(){
    super();
    this.filterType='';
    this.id = ''
    this.fromDate = null;
    this.toDate = null;
    this.riskRef = [];
this.riskArea = [];
this.riskCategory=[];
this.riskTitle = [];
this.complianceTopic = [];
this.entitiesImpacted = [];
this.riskOwner=[];
this.riskDescription = [];
this.applicableRules = [];
this.inherentRiskRating=[];
this.residualRiskRating=[];
   
  }
}
export interface riskControlDropdownDto {
    id: string;
    item: string;
    icon?: string;
    classStyle?: string;
  }
 export interface riskcontrolfiltersaveDto{
    result :RiskControlFilter
    riskRef: riskControlDropdownDto[];
    riskArea: riskControlDropdownDto[];
    riskCategory: riskControlDropdownDto[];
    riskTitle: riskControlDropdownDto[];
    complianceTopic: riskControlDropdownDto[];
    entitiesImpacted: riskControlDropdownDto[];
    riskOwner: riskControlDropdownDto[];
    riskDescription: riskControlDropdownDto[];
    applicableRules: riskControlDropdownDto[];
    inherentRiskRatingList:riskControlDropdownDto[];
    residualRiskRatingList:riskControlDropdownDto[];
    inherentRisk:riskControlDropdownDto;
 }